// extracted by mini-css-extract-plugin
export default {"productGrid":"r1-z","centerLink":"s1-z","productSection":"t1-z","item":"u1-z","ctaButton":"v1-z"};